import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CONSTS } from './radio-button.constants';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  standalone: false,
})
export class RadioButtonComponent {
  @Input() firstOptionValue!: string;
  @Input() firstOptionName!: string;
  @Input() secondOptionValue!: string;
  @Input() secondOptionName!: string;

  @Input() header = CONSTS.HEADER;
  @Input() isDisabled = false;
  @Input() radioModel!: string;
  @Input() hasPadding = true;

  @Output() buttonChange = new EventEmitter<Event>();
  readonly CONSTS = CONSTS;

  valueChange($event: Event) {
    this.buttonChange.emit($event);
  }
}
